import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';

class NumberServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getList(params = {}) {
    return this.http.get('/calltracking', { params: params });
  }

  removeItem(id) {
    return this.http.delete(`/${id}/calltracking`);
  }

  createItem(ids = []) {
    return this.http.put('/calltracking', { ids: ids });
  }

  getCandidates() {
    return this.http.get('/calltracking/candidates');
  }
}

export const NumberService = new NumberServiceClass({
  api_version: 2,
  resource: 'phones'
});
